import { AnnotationRendererV1 } from './v1/AnnotationRendererV1';
import { AnnotationRendererV2 } from './v2/AnnotationRendererV2';
import { AnnotationCreatorV3 } from './v3/AnnotationCreatorV3';
import { AnnotationRendererV3 } from './v3/AnnotationRendererV3';
import { AnnotationSchemaV3 } from './v3/AnnotationSchemaV3';
const VERSION_1 = 1;
const VERSION_2 = 2;
const VERSION_3 = 3;
export class AnnotationFactory {
    static getRenderer(version, element, annotations, annotationHelper) {
        let renderer = null;
        if (version === VERSION_1) {
            renderer = new AnnotationRendererV1(element, annotations, annotationHelper);
        }
        else if (version === VERSION_2) {
            renderer = new AnnotationRendererV2(element, annotations, annotationHelper);
        }
        else if (version === VERSION_3) {
            renderer = new AnnotationRendererV3(element, annotations, annotationHelper);
        }
        else {
            throw new Error(`Version {version} not implemented`);
        }
        return renderer;
    }
    static getCreator(version, element, annotations, annotationHelper) {
        let creator = null;
        if (version === VERSION_3) {
            creator = new AnnotationCreatorV3(element, annotations, annotationHelper);
        }
        return creator;
    }
    /**
     * Get the schema definition for the specified version
     * @param {number} version
     * @returns {AnnotationSchemaV3}
     */
    static getSchema(version) {
        let schema = null;
        if (version === VERSION_3) {
            schema = AnnotationSchemaV3;
        }
        return schema;
    }
}
//# sourceMappingURL=AnnotationFactory.js.map